import React, { Component } from "react";
import _ from "lodash";
import { ReactSortable } from "react-sortablejs";
import Item from "./Item";
import classnames from 'classnames'
import Button from "components/Button";
import { getGroupColors, getResultData, groupColorArray } from "lib/helper"
import EditableText from 'components/EditableText'
import { installClickOutside } from 'lib/hooks'

function notEqualItemList(oldData, newData) {
  if (oldData.length !== newData.length)
    return true
  for (let j = 0; j < oldData.length; j++) {
    if (oldData[j].id !== newData[j].id)
      return true
  }
  return false
}

function notEqual(oldData, newData) {
  if (oldData.length !== newData.length)
    return true
  for (let i = 0; i < oldData.length; i++) {
    const og = oldData[i]
    const ng = newData[i];
    if (og.group_name !== ng.group_name)
      return true
    if (notEqualItemList(og.items, ng.items))
      return true
  }
  return false
}

function SortableItemsWrapper({ items, setList, setChoosen, choosen, linkmap, labels, width, height, demo, groupKey }) {
  if (!items) return null;

  let dragClass = 'drag-item-demo';
  let color = undefined;

  if (demo === 'challenge') {
    color = '#' + groupColorArray[groupKey];
  }

  return <ReactSortable
    list={items}
    setList={setList}
    animation={250}
    group="all-group"
    ghostClass="ghost-item"
    dragClass={dragClass}
    fallbackClass="fallback-item"
    forceFallback={true}
    fallbackOnBody={true}
  >
    {items.map(item => (
      <Item
        key={`item-${item.id}`}
        item={item}
        onClick={() => setChoosen(item)}
        choosen={choosen}
        linkmap={linkmap}
        labels={labels}
        width={width}
        height={height}
        color={color}
      />
    ))}
  </ReactSortable>
}

function GroupWrapper({ renderGroup, groupKey, group }) {
  return <div className={`group group-${groupKey}`} data-custom={group.custom}>{renderGroup(groupKey, group)}</div>
}

function SortableGroupsWrapper({ groups, setList, renderGroup, className, deselect, demo }) {
  if (!groups) return null;

  let dragClass = 'drag-group';
  if (demo) {
    dragClass = dragClass + '-demo';
  }

  return <ReactSortable
    list={groups}
    setList={setList}
    animation={250}
    ghostClass="ghost-group"
    dragClass={dragClass}
    fallbackClass="fallback-group"
    forceFallback={true}
    fallbackOnBody={true}
    className={className}
  >
    {
      groups.map((group, i) => {
        return (
          <GroupWrapper key={`group-${i}`} deselect={deselect} renderGroup={renderGroup} group={group} groupKey={i} />
        )
      })
    }
  </ReactSortable>
}

function GroupHeader({ group, onRemove, onChangeTitle, onClick }) {
  return (
    <div className="group-header">
      <EditableText value={group.group_name} setValue={onChangeTitle} onClick={onClick} selected={group.select} />
      <div className={classnames("close", { hidden: !group.select })} onMouseDown={onRemove}>✖</div>
    </div>
  )
}

class GroupList extends Component {
  constructor(props) {
    super(props);
    this.maxLabelWidth = {}
    this.calcMaxLabelWidth(props.data.result.nodes)
    this.state = {
      ...this.convertData(props.data),
      height: 50,
      width: this.maxLabelWidth['name'],
    }
    this.lastData = this.state.data
    this.linkmap = this.getLinkMap(props.data)
    this.undoStack = [this.state.data,];
    window.addEventListener('keypress', this.handleKeyPress);
  }

  handleKeyPress = (ev) => {
    const mac = navigator.platform.indexOf('Mac') > -1;
    if (((mac && ev.metaKey) || (!mac && ev.ctrlKey)) && ev.keyCode === 26) {
      this.undo();      
    }
  }

  calcMaxLabelWidth = (nodes) => {
    nodes.forEach(node => {
      _.forEach(node, (value, key) => {
        if (typeof value === 'string') {
          const width = Math.max(...value.split(' ').map(s => this.calcWidth(s)))
          if (!this.maxLabelWidth[key]) {
            this.maxLabelWidth[key] = Math.max(width, 88)
          } else {
            this.maxLabelWidth[key] = Math.max(width, this.maxLabelWidth[key])
          }
        }
      })
    })
  }

  convertData = original_data => {
    const c = getGroupColors()

    const participants = _.keyBy(original_data.participants.data.map(p => ({
      id: p.id,
      name: ((p.sfirstname || '') + ' ' + (p.slastname || '')).trim(),
      department: p.sdepartment
    })), 'id')
    const users = _.groupBy(participants, 'department')
    const departments = Object.keys(users)
    this.colorOptions = {}
    departments.forEach(group => {
      this.colorOptions[group] = "#" + c(group)
    })

    if (original_data.result && original_data.result.save) {
      return { data: original_data.result.save }
    }
    Object.values(participants).forEach(p => {
      p['color'] = this.colorOptions[p.department]
    })

    if (original_data.result && original_data.result.nodes) {
      const nodes = original_data.result.nodes.map(node => ({
        ...node,
        ...participants[node.id],
      }))
      const assigned = _.map(_.groupBy(nodes, 'group'), (items, group) => ({
        group_name: original_data.group_mapping[group],
        items
      }))
      // assigned.sort((group1, group2) => group2.items.length - group1.items.length)
      return {
        data: {
          assigned,
          unassigned: []
        }
      }
    }
    return {
      data: []
    }
  };

  getLinkMap = (data) => {
    let ret = {}
    data.result.links.forEach(link => {
      if (link.source && link.target)
        ret[`${link.source.id}-${link.target.id}`] = true
    })
    return ret
  }

  addGroup = () => {
    let groupCount = this.state.data.assigned.length;
    // eslint-disable-next-line no-loop-func
    while (this.state.data.assigned.find(group => group.group_name === `Group ${groupCount + 1}`))
      groupCount += 1

    this.setState({
      data: {
        ...this.state.data,
        assigned: [
          ...this.state.data.assigned,
          {
            group_name: `Group ${groupCount + 1}`,
            custom: true,
            items: []
          }
        ]
      }
    }, () => {
      this.save();
      if (this.props.onGroupsChanged) {
        this.props.onGroupsChanged();
      }
      // --- Tour integration: jump to next step if available ---
      if (window.tourNextStep) {
        window.tourNextStep();
      }
    });
  }

  save = (undo = false) => {
    const { valid } = getResultData(this.state.data, this.props.data.participants.data);
    if (valid && (notEqual(this.state.data.assigned, this.lastData.assigned) || notEqualItemList(this.state.data.unassigned, this.lastData.unassigned))) {
      this.props.save(this.state.data, true)
      this.lastData = this.state.data
      if (!undo) {
        this.undoStack.push(this.state.data);
      }
    }
  }

  setAssignedList = (key, list) => {
    const newList = [...this.state.data.assigned];
    newList[key] = {
      ...newList[key],
      items: list
    }
    this.setState({
      data: {
        ...this.state.data,
        assigned: newList,
      }
    }, () => this.save())
  }

  setChoosen = (item) => {
    this.setState({
      choosen: this.state.choosen && item.id === this.state.choosen.id ? null : item
    }, () => {
      if (this.props.setChoosen) {
        this.props.setChoosen(this.state.choosen);
      }
    })
    return true;
  }

  deselectItem = () => {
    if (this.state.choosen) {
      this.setState({
        choosen: null
      }, () => {
        if (this.props.setChoosen) {
          this.props.setChoosen(this.state.choosen);
        }
      })
    }
  }

  removeGroup = (key) => {
    let newGroups = [...this.state.data.assigned]
    let [removed] = newGroups.splice(key, 1)
    this.setState({
      data: {
        assigned: newGroups,
        unassigned: [...this.state.data.unassigned, ...removed.items]
      },
    }, () => {
      this.save();
      if (this.props.onGroupsChanged) {
        this.props.onGroupsChanged();
      }
    })
  }

  changeTitle = (key, value, confirm) => {
    let ret = null
    if (this.state.data.assigned.find((group, id) => key !== id && group.group_name === value)) {
      ret = "Duplicate group name exist"
    }
    if (!value) {
      ret = "Group name can't be empty"
    }
    const newData = [...this.state.data.assigned]
    newData[key].group_name = value
    this.setState({
      data: {
        ...this.state.data,
        assigned: newData
      }
    }, () => {
      if (confirm && !ret) this.save()
    })
    return ret
  }

  selectGroup = (key) => {
    const newState = this.state.data.assigned.map(group => ({ ...group, select: false }))
    newState[key].select = true
    this.setState({
      data: {
        ...this.state.data,
        assigned: newState
      }
    }, () => {
      if (this.props.setChoosen) {
        this.props.setChoosen(newState[key].items);
      }
    });
  }

  deselectGroup = () => {
    const newState = this.state.data.assigned.map(group => ({ ...group, select: false }))
    this.setState({
      data: {
        ...this.state.data,
        assigned: newState
      }
    }, () => {
      if (this.props.setChoosen) {
        this.props.setChoosen(null);
      }
    })
  }

  renderGroup = (key, group) => {
    const { choosen } = this.state
    return (
      <div
        className={classnames('group-content', { selected: group.select })}
        data-id={key}
      >
        <GroupHeader
          group={group}
          onRemove={() => this.removeGroup(key)}
          onChangeTitle={(value, confirm) => this.changeTitle(key, value, confirm)}
          onClick={() => this.selectGroup(key)}
        />
        <div
          className={classnames("cards-wrapper", { "active": choosen === key })}
          style={{ width: `${this.state.width * 3 + 51}px` }}
        >
          <SortableItemsWrapper
            items={group.items}
            setList={list => this.setAssignedList(key, list)}
            choosen={choosen}
            setChoosen={this.setChoosen}
            linkmap={this.linkmap}
            deselect={this.deselectItem}
            labels={this.props.labels}
            width={this.state.width}
            height={this.state.height}
            demo={this.props.demo}
            groupKey={key}
          />
        </div>
      </div>
    )
  }


  setGroupOrder = (groups) => {
    this.setState({
      data: {
        ...this.state.data,
        assigned: groups
      }
    }, () => this.save())
  }

  calcWidth = (word) => {
    let f = '16px Open Sans'
    let element = document.createElement('canvas')
    let context = element.getContext('2d')
    context.font = f
    let width = context.measureText(word).width
    return width
  }

  componentDidMount() {
    this.groupSubscriber = installClickOutside('group-content', this.deselectGroup)
    this.cardSubscriber = installClickOutside('card-item', this.deselectItem)
  }

  updateCardSize = () => {
    const width = Math.max(...this.props.labels.map(label => this.maxLabelWidth[label])) + 9
    this.setState({
      width
    }, this.updateHeight)
  }

  updateHeight = () => {
    const heights = [...document.getElementsByClassName('card-name')].map(element => element.offsetHeight)
    const height = Math.max(...heights)
    this.setState({
      height
    })
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.groupSubscriber)
    document.removeEventListener('mousedown', this.cardSubscriber)
    window.removeEventListener('keypress', this.handleKeyPress);
  }

  setunassigned = (list) => {
    this.setState({
      data: {
        ...this.state.data,
        unassigned: list
      }
    }, () => this.save())
  }

  undo = () => {
    if (this.undoStack.length > 1) {
      this.undoStack.splice(this.undoStack.length - 1);
      this.setState({
        data: this.undoStack[this.undoStack.length - 1],
      }, () => this.save(true));
    }
  }

  render() {
    let { data: { assigned, unassigned }, choosen } = this.state

    return (
      <div className="mt-2">
        { !this.props.hideTitle && <h4>Groups</h4>}
        <SortableGroupsWrapper
          groups={assigned}
          renderGroup={this.renderGroup}
          setList={this.setGroupOrder}
          className="groups-wrapper"
          deselect={this.deselectGroup}
          demo={this.props.demo}
        />
        <div className="group">
          <Button
            text="Add group"
            className="button"
            icon="plus.svg#plus"
            onClick={this.addGroup}
            style={{ margin: "10px" }}
          />
          <Button
            text="Undo"
            className="button"
            icon="plus.svg#plus"
            onClick={this.undo}
            style={{ margin: "10px" }}
            disabled={this.undoStack.length === 1}
          />          
        </div>
        <div>
          <SortableItemsWrapper
            items={unassigned}
            setList={this.setunassigned}
            setChoosen={this.setChoosen}
            choosen={choosen}
            linkmap={this.linkmap}
            labels={this.props.labels}
            width={this.state.width}
            height={this.state.height}
            demo={this.props.demo}
            groupKey={this.state.data.assigned.length}
          />
        </div>
      </div>
    );
  }
}

export default GroupList;
